import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'fiveCard',
      component: resolve => require(["@/pages/fiveCard"], resolve),                      
    },
		
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js